import { Panel } from '../../../../components/containers/Panel';
import { PanelHeader } from '../../../../components/containers/Panel/PanelHeader.view';
import React from 'react';
import { GetBitlyAccounts_workspace_bitlyAccounts } from '../../../../models/legacy-graphql';
import { SocialProfileListItem } from '../../../../components/socialProfiles/SocialProfileListItem';
import { MappedProfileType } from '../../../../components/socialProfiles/SocialProfileListItem/SocialProfileListItem.view';
import { ContainerListItem } from '../../../../components/actions/ListItem/ListItem.view';

export type BitlyAccountPanelViewProps = {
  areAccountsConnected: boolean;
  bitlyList: GetBitlyAccounts_workspace_bitlyAccounts[];
  bitlyAction: (isReconnect?: boolean, profile?: MappedProfileType) => void;
  removeBitlyAccountHandler: (bitlyId: string, confirmed?: boolean) => void;
};

export const BitlyAccountPanelView = (props: BitlyAccountPanelViewProps): JSX.Element => {
  const panelTitle = props.areAccountsConnected ? 'Connected Bitly Accounts' : 'Disconnected Bitly Accounts';
  const bitlyListItemMenu = (profile: MappedProfileType): ContainerListItem[] => {
    const menu = [
      {
        action: () => props.removeBitlyAccountHandler(profile.id),
        label: 'Remove'
      }
    ];

    if (props.areAccountsConnected) {
      menu.unshift({
        action: () => props.bitlyAction(true, profile),
        label: 'Re-connect'
      });
    }

    return menu;
  };

  const bitlyListItems: JSX.Element[] = props.bitlyList.map(account => (
    <div key={account.id} className={'cell shrink margin-bottom-small-16'}>
      <SocialProfileListItem
        profile={account}
        listItems={bitlyListItemMenu(account)}
        reconnect={() => props.bitlyAction(true, account)}
      />
    </div>
  ));

  return (
    <Panel>
      <PanelHeader title={panelTitle} />
      <div className={'cell small-6 margin-bottom-small-32'}>{bitlyListItems}</div>
    </Panel>
  );
};
